import { css } from "@styled-system/css";
import { flex } from "@styled-system/patterns";

export const headerClass = css({
	paddingBottom: "24",
});

export const titleRowClass = flex({
	alignItems: "center",
	justifyContent: "space-between",
	gap: "8",
});

export const buttonWrapperClass = flex({
	gap: "8",
	marginTop: "8",
});

export const guestNoticeClass = css({
	marginTop: "8",
	fontWeight: "bold",
	color: "warning.100",
});

export const guestCustomerIdsClass = css({
	marginTop: "4",
	fontSize: "12",
	color: "shade.40",
});
